import * as i0 from '@angular/core';
import { Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import '@inera/ids-core/components/footer/register';
const _c0 = ["*"];
function IDFooterComponent_ids_footer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ids-footer", 1);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.type)("headline", ctx_r0.headline)("srheadline", ctx_r0.srheadline)("subheadline", ctx_r0.subheadline)("servicename", ctx_r0.servicename)("cols", ctx_r0.cols)("linkcol1", ctx_r0.linkcol1)("linkcol2", ctx_r0.linkcol2)("linkcol3", ctx_r0.linkcol3);
  }
}
class IDFooterComponent {
  constructor() {}
  type = '';
  headline = '';
  srheadline = '';
  servicename = '';
  subheadline = '';
  cols = 3;
  linkcol1 = '2';
  linkcol2 = '2';
  linkcol3 = '2';
  static ɵfac = function IDFooterComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDFooterComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: IDFooterComponent,
    selectors: [["id-footer"]],
    inputs: {
      type: "type",
      headline: "headline",
      srheadline: "srheadline",
      servicename: "servicename",
      subheadline: "subheadline",
      cols: "cols",
      linkcol1: "linkcol1",
      linkcol2: "linkcol2",
      linkcol3: "linkcol3"
    },
    standalone: false,
    ngContentSelectors: _c0,
    decls: 1,
    vars: 1,
    consts: [[3, "type", "headline", "srheadline", "subheadline", "servicename", "cols", "linkcol1", "linkcol2", "linkcol3", 4, "ngIf"], [3, "type", "headline", "srheadline", "subheadline", "servicename", "cols", "linkcol1", "linkcol2", "linkcol3"]],
    template: function IDFooterComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, IDFooterComponent_ids_footer_0_Template, 2, 9, "ids-footer", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.type);
      }
    },
    dependencies: [i1.NgIf],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDFooterComponent, [{
    type: Component,
    args: [{
      selector: 'id-footer',
      template: "<ids-footer \r\n  *ngIf=\"type\"\r\n  [type]=\"type\"\r\n  [headline]=\"headline\"\r\n  [srheadline]=\"srheadline\"\r\n  [subheadline]=\"subheadline\"\r\n  [servicename]=\"servicename\"\r\n  [cols]=\"cols\"\r\n  [linkcol1]=\"linkcol1\"\r\n  [linkcol2]=\"linkcol2\"\r\n  [linkcol3]=\"linkcol3\">\r\n  <ng-content></ng-content>\r\n</ids-footer>"
    }]
  }], () => [], {
    type: [{
      type: Input
    }],
    headline: [{
      type: Input
    }],
    srheadline: [{
      type: Input
    }],
    servicename: [{
      type: Input
    }],
    subheadline: [{
      type: Input
    }],
    cols: [{
      type: Input
    }],
    linkcol1: [{
      type: Input
    }],
    linkcol2: [{
      type: Input
    }],
    linkcol3: [{
      type: Input
    }]
  });
})();
class IDFooterModule {
  static ɵfac = function IDFooterModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IDFooterModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: IDFooterModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IDFooterModule, [{
    type: NgModule,
    args: [{
      declarations: [IDFooterComponent],
      exports: [IDFooterComponent],
      imports: [CommonModule],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { IDFooterComponent, IDFooterModule };
